module.exports = __webpack_public_path__ + "static/media/newsletter.14805263.png";